import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString } from '../common.mjs';
import { BASE_PATH } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const FileRestrictionControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileSourceTypeRestrictions: (options = {}) => {
      const localVarPath = `/api/v2/file/restrictions/source-types`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getFileSourceTypeRestrictions",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @param {FileRestrictionControllerApiGetFileSourceTypeRestrictionsByTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileSourceTypeRestrictionsByTypes: ({ names }, options = {}) => {
      assertParamExists("getFileSourceTypeRestrictionsByTypes", "names", names);
      const localVarPath = `/api/v2/file/restrictions/source-types/by-names`;
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      if (names) {
        localVarQueryParameter["names"] = Array.from(names);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getFileSourceTypeRestrictionsByTypes",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const FileRestrictionControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = FileRestrictionControllerApiAxiosParamCreator();
  return {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileSourceTypeRestrictions(options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getFileSourceTypeRestrictions(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @param {FileRestrictionControllerApiGetFileSourceTypeRestrictionsByTypesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getFileSourceTypeRestrictionsByTypes(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getFileSourceTypeRestrictionsByTypes(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const getFileSourceTypeRestrictionsRemote = makeRemoteWithOpenapiGenerator({
  requestArgs: FileRestrictionControllerApiAxiosParamCreator().getFileSourceTypeRestrictions(),
  requestFn: FileRestrictionControllerApiFp().getFileSourceTypeRestrictions
});
makeRemoteWithOpenapiGenerator({
  requestArgsCreator: FileRestrictionControllerApiAxiosParamCreator().getFileSourceTypeRestrictionsByTypes,
  requestFn: FileRestrictionControllerApiFp().getFileSourceTypeRestrictionsByTypes
});

export { FileRestrictionControllerApiAxiosParamCreator, FileRestrictionControllerApiFp, getFileSourceTypeRestrictionsRemote };
//# sourceMappingURL=file-restriction-controller-api.mjs.map
